import { createSlice } from '@reduxjs/toolkit';
import { LOGOUT } from '../../../utils/constants';
import {
  createFeedCommentBuilder,
  createFeedReplyBuilder,
  deleteFeedCommentBuilder,
  getFeedBuilder,
  getFeedCommentsBuilder,
  getFeedRepliesBuilder,
  getTrendingFeedBuilder,
  likeFeedCommentBuilder,
  likeFeedItemBuilder,
  shareFeedItemBuilder,
  unlikeFeedCommentBuilder,
  unlikeFeedItemBuilder,
} from './builder';

export const EMPTY_FEED_BUCKET = {
  data: [],
  nextCursor: null,
  hasMore: true,
  limit: 20,
  pending: false,
  fetchMorePending: false,
  loaded: false,
  createPending: false,
  requestId: null,
};

export const EMPTY_TRENDING_BUCKET = {
  data: [],
  phase: 'TRENDING',
  cursor: null,
  seed: null,
  hasMore: true,
  limit: 20,
  pending: false,
  fetchMorePending: false,
  loaded: false,
  requestId: null,
};

const createInitialState = () => ({
  getFeedInfo: {
    ...EMPTY_FEED_BUCKET,
  },
  getTrendingInfo: {
    ...EMPTY_TRENDING_BUCKET,
  },
  commentsByFeedId: {},
  repliesByCommentId: {},
  pending: {
    likeFeedItem: false,
    unlikeFeedItem: false,
    shareFeedItem: false,
    createFeedComment: false,
    createFeedReply: false,
    likeFeedComment: false,
    unlikeFeedComment: false,
    deleteFeedComment: false,
  },
});

export const feedSlice = createSlice({
  name: 'feed',
  initialState: createInitialState(),
  reducers: {
    resetFeedInfo: state => {
      state.getFeedInfo = { ...EMPTY_FEED_BUCKET };
    },
    resetTrendingInfo: state => {
      state.getTrendingInfo = { ...EMPTY_TRENDING_BUCKET };
    },
  },
  extraReducers: builder => {
    getFeedBuilder(builder);
    getTrendingFeedBuilder(builder);
    likeFeedItemBuilder(builder);
    unlikeFeedItemBuilder(builder);
    shareFeedItemBuilder(builder);
    getFeedCommentsBuilder(builder);
    createFeedCommentBuilder(builder);
    getFeedRepliesBuilder(builder);
    createFeedReplyBuilder(builder);
    likeFeedCommentBuilder(builder);
    unlikeFeedCommentBuilder(builder);
    deleteFeedCommentBuilder(builder);
    builder.addCase(LOGOUT, () => createInitialState());
  },
});

export const { resetFeedInfo, resetTrendingInfo } = feedSlice.actions;

export const selectGetFeedInfo = state => state.feedInfo.getFeedInfo;
export const selectGetTrendingInfo = state => state.feedInfo.getTrendingInfo;
export const selectFeedCommentsInfo = (state, feedItemId) => {
  if (!feedItemId) {
    return EMPTY_FEED_BUCKET;
  }

  return state.feedInfo.commentsByFeedId[feedItemId] || EMPTY_FEED_BUCKET;
};
export const selectFeedRepliesInfo = (state, feedCommentId) => {
  if (!feedCommentId) {
    return EMPTY_FEED_BUCKET;
  }

  return state.feedInfo.repliesByCommentId[feedCommentId] || EMPTY_FEED_BUCKET;
};
export const selectFeedRepliesByCommentId = state => state.feedInfo.repliesByCommentId;
export const selectFeedPending = state => state.feedInfo.pending;

export default feedSlice.reducer;
